// used to generate placeholder IDs for inspection parts and distinguish them from
// the IDs of parts that already exist in the DB
export const getPlaceholderId = () => new Date().getTime();
export const isPlaceholderId = (id: number) => id > 1000000000;
